export const CHAT_SERVICES = {
    ChatStore: Symbol.for('ChatStoreInterface'),
};
